import store from 'utils/store/withMiddleware'
import toastNotification from 'pug/toastNotification'
import { ADD_PLAN, REMOVE_PLAN } from 'messages'
import handleAddonsExternal from '../controller/handleAddonsExternal'

function handleToggleAddonExternal(): void {
  
  const deletePlans = !this.checked
  const id = this.id.split('--')

  const planId = id[1]
  const addonId = id[3]
  const state = store.getState()
  const { addonsExternalByPlan } = state
  addonsExternalByPlan[planId] = addonsExternalByPlan[planId] ?? []

  let newExternalPlanSelected = addonId
  if (deletePlans) {
    newExternalPlanSelected = undefined
    addonsExternalByPlan[planId] = addonsExternalByPlan[planId].filter(addonsExternal => addonsExternal !== addonId)
  } else {
    addonsExternalByPlan[planId] = [addonId]
  }

  handleAddonsExternal({ ...state, externalPlanSelected: newExternalPlanSelected, addonsExternalByPlan }, planId)

  toastNotification(deletePlans ? REMOVE_PLAN : ADD_PLAN)
}
export default handleToggleAddonExternal
